import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { GetStoreDetailRole } from '../../../const/constant';
const detailroleId = GetStoreDetailRole(localStorage.getItem('current_store_id'))
const EditRentall = ({
  editType, isShow, editData, onChangeFunc, saveFunc, toggleFunc, rentType = 'advance', tenantList = []
}) => {
  const {
    prepaymentDate,
    prepaymentAmount,
    tenantName,
    paymentCode,
    rentalSpace,
    rentalDate,
    rentalAmount,
    hasServiceFee, // 圖片中沒有明確對應的單獨欄位
    serviceFee, // 圖片中沒有明確對應的單獨欄位
    serviceFeePercent, // 圖片中沒有明確對應的單獨欄位
    hasMealFee,
    mealFee,
    totalAmount,
    invoiceNumber,
    itemType,
    remarks,
    status,
    code
  } = editData;

  // 租賃空間的選項，與圖片中左側和中間的空間對應
  const rentalSpaceOptions = [
    { label: "C+D區", value: "C+D區" },
    { label: "C區矮沙發+D區", value: "C區矮沙發+D區" },
    { label: "D區", value: "D區" },
    { label: "G區(大教室1)", value: "G區(大教室1)" },
    { label: "F區(大教室2)", value: "F區(大教室2)" },
    { label: "I區", value: "I區" },
    { label: "H區(小教室1)", value: "H區(小教室1)" },    
    { label: "J區(小教室2)", value: "J區(小教室2)" },
    { label: "A區", value: "A區" },
    { label: "E區(實驗教室)", value: "E區(實驗教室)" },


  ];

  const handleSave = (e) => {
    e.preventDefault();
    
    
    // 預收租借驗證
    if (rentType === 'advance') {
      if (!prepaymentDate) {
        alert('預收租借時，預款日期為必填！');
        return;
      }
    }
    
    // 現場租借驗證
    if (rentType === 'onsite') {
      if (!rentalDate) {
        alert('現場租借時，承租日期為必填！');
        return;
      }
    }
    
    saveFunc();
  };
  console.log('roleId'+detailroleId);
  return (
    <div className="u-editblock fadeIn " style={{ display: isShow ? 'flex' : 'none', overflow:'auto' ,justifyContent: 'center' }}>
      <div className="form-block u-rentall" style={{ minWidth: '700px', border: '1px solid black', padding: '0' }}>
        <div className="u-small-title" style={{ padding: '16px', border: '1px solid black' }}>
          {editType === 'ADD' ? '新增' : '編輯'}租借資料 - 表格樣式
        </div>
        <form className="u-form" style={{ margin: '0' }}>
          {/* 預收資訊區塊，僅預收租借顯示 */}
            <div style={{ display: 'flex', border: '1px solid black' }}>
              <div style={{ flex: 1, padding: '8px', display: 'flex' }}>
                <label className="u-form__label" style={{ fontWeight: 'bold' }}>編碼:{code}</label>
              </div>
            </div>
          {rentType === 'advance' && (
            <div style={{ display: 'flex', border: '1px solid black' }}>
              {/* 預款日期 */}
              <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex' }}>
                <label className="u-form__label" style={{ fontWeight: 'bold' }}>預款日期</label>
                <DatePicker
                  disabled={detailroleId == '17'}
                  locale="zh-tw"
                  placeholderText="請選擇日期"
                  dateFormat="YYYY-MM-DD"
                  autoComplete="off"
                  className="u-form__input"
                  selected={typeof prepaymentDate === 'string'? moment(prepaymentDate) : ''}
                  onChange={e => onChangeFunc('prepaymentDate', e.format('YYYY-MM-DD'))}
                  selectsStart
                />
              </div>
              {/* 預收金額 */}
              <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex' }}>
                <label className="u-form__label" style={{ fontWeight: 'bold' }}>預收金額</label>
                <input
                  disabled={detailroleId == '17'}
                  type="number"
                  value={prepaymentAmount || ''}
                  onChange={e => onChangeFunc('prepaymentAmount', e.target.value)}
                  className="u-form__input underline"
                  style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
                />
              </div>
              {/* 編碼 */}

            </div>
          )}
          {/* 承租人與收款後五碼 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            {/* 承租人 */}
            <div style={{ flex: 1, padding: '8px',borderRight: '1px solid black', display: 'flex' }}>
              <label className="u-form__label" style={{ fontWeight: 'bold' }}>承租人(請輸入完整名稱)</label>
              <input
                list="tenantNameList"
                value={tenantName || ''}
                onChange={e => onChangeFunc('tenantName', e.target.value)}
                className="u-form__input underline"
                style={{  border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
              />
              <datalist id="tenantNameList">
                {tenantList.map((t, i) => (
                  <option key={i} value={t} />
                ))}
              </datalist>
            </div>
            {/* 收款後五碼，僅預收租借顯示 */}
            {rentType === 'advance' && (
              <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex' }}>
                <label className="u-form__label" style={{ fontWeight: 'bold' }}>收款後五碼</label>
                <input
                  disabled={detailroleId == '17'}
                  value={paymentCode || ''}
                  onChange={e => onChangeFunc('paymentCode', e.target.value)}
                  className="u-form__input underline"
                  style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
                />
              </div>
            )}
          </div>

          {/* 承租空間 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' }}>承租空間</div>
            <div style={{ flex: 1, padding: '8px' }}>
              <select
                value={rentalSpace || ''}
                onChange={e => onChangeFunc('rentalSpace', e.target.value)}
                className="u-form__input underline"
                style={{ height: '36px', minHeight: '36px', fontSize: '16px', lineHeight: '1.5', padding: '6px 12px', width: '100%', border: '1px solid #ccc' }}
              >
                <option value="">請選擇</option>
                {rentalSpaceOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              {/*
                * 由於圖片中空間是以複選框方式呈現多個選項，
                * 這裡使用單選下拉菜單，並用一個備註來說明多選的可能性。
                * 如果需要實現多選邏輯，需要調整 editData 結構和 onChangeFunc 邏輯。
                */}
            </div>
          </div>

          {/* 承租日期與場租金額 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            {/* 承租日期 */}
            <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex' }}>
              <label className="u-form__label" style={{ fontWeight: 'bold' }}>承租日期</label>
            <DatePicker
                locale="zh-tw"
                placeholderText="請選擇日期"
                dateFormat="YYYY-MM-DD"
                autoComplete="off"
                className="u-form__input"
                selected={typeof rentalDate === 'string'? moment(rentalDate):''}

                onChange={(e) => {
                    onChangeFunc('rentalDate', e.format('YYYY-MM-DD'))
                }}
                selectsStart
            />
            </div>
            {/* 場租金額 */}
            <div style={{ flex: 1, padding: '8px' }}>
                            <div style={{ marginBottom: '8px' }}>
                <label className="u-form__label" style={{ fontWeight: 'bold' }}>場租金額</label>
              <input
                type="number"
                value={rentalAmount || ''}
                onChange={e => onChangeFunc('rentalAmount', e.target.value)}
                className="u-form__input underline"
                style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px', textAlign: 'right' }}
              />
</div>

              <div style={{ marginBottom: '8px' }}>
                <span style={{ marginRight: '8px' }}>場租服務費</span>
                {/* 服務費的有無和百分比（簡化為輸入欄位，假設您在計算時仍需要這些數據） */}
                <label style={{ marginRight: '16px' }}><input type="checkbox" checked={hasServiceFee === false} onChange={e => onChangeFunc('hasServiceFee', !e.target.checked)} /> 無</label>
                <label style={{ marginRight: '16px' }}><input type="checkbox" checked={hasServiceFee === true} onChange={e => onChangeFunc('hasServiceFee', e.target.checked)} /> 有</label>

                <span style={{ marginRight: '8px' }}>金額:</span>
                <input
                  type="number"
                  value={serviceFee || ''}
                  onChange={e => onChangeFunc('serviceFee', e.target.value)}
                  style={{ width: '80px', border: '1px solid #ccc', padding: '2px', marginRight: '8px', textAlign: 'right' }}
                />
                <span style={{ marginRight: '8px' }}>(</span>
                <input
                  type="number"
                  value={serviceFeePercent || ''}
                  onChange={e => onChangeFunc('serviceFeePercent', e.target.value)}
                  style={{ width: '40px', border: '1px solid #ccc', padding: '2px', textAlign: 'right' }}
                />
                <span>%)</span>
              </div>
            </div>
          </div>

          {/* 結算金額/服務費/餐飲費 */}
          <div style={{ display: 'flex', borderLeft: '1px solid black', borderRight: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' }}>結算金額</div>
            <div style={{ flex: 1, padding: '8px' }}>

              <div>
                <span style={{ marginRight: '8px' }}>餐點+服務費</span>
                {/* 餐點費的有無和金額 */}
                <label style={{ marginRight: '16px' }}><input type="checkbox" checked={hasMealFee === false} onChange={e => onChangeFunc('hasMealFee', !e.target.checked)} /> 無</label>
                <label style={{ marginRight: '16px' }}><input type="checkbox" checked={hasMealFee === true} onChange={e => onChangeFunc('hasMealFee', e.target.checked)} /> 有</label>

                <span style={{ marginRight: '8px' }}>金額:</span>
                <input
                  type="number"
                  value={mealFee || ''}
                  onChange={e => onChangeFunc('mealFee', e.target.value)}
                  style={{ width: '150px', border: '1px solid #ccc', padding: '2px', textAlign: 'right' }}
                />
                <span> (含稅)</span>
              </div>
            </div>
          </div>

          {/* 總收款金額 */}
          <div style={{ display: 'flex', borderLeft: '1px solid black', borderRight: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
              總收款金額
            </div>
            <div style={{ flex: 1, padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <input
                type="number"
                value={totalAmount || ''}
                onChange={e => onChangeFunc('totalAmount', e.target.value)}
                className="u-form__input underline"
                style={{ border: '1px solid #ccc', padding: '2px', textAlign: 'right', width: '200px' }}
              />

            </div>
              <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <span>(已含預收金額)</span>
</div>

              <div style={{ flex: 1,  display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              {rentalAmount && (Number(mealFee || 0) + Number(serviceFee || 0) + Number(rentalAmount || 0)) !== Number(totalAmount || 0) && (
                <span style={{ marginRight: '10px', color: 'red' }}>
                  ⚠️ 預估金額(場租金額+餐點+服務費): <strong>{Number(mealFee || 0) + Number(serviceFee || 0) + Number(rentalAmount || 0)}</strong>
                </span>
              )}
              </div>
          </div>

          {/* 發票號碼與品項 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' }}>發票號碼</div>
            <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex' }}>
              <input
                value={invoiceNumber || ''}
                onChange={e => onChangeFunc('invoiceNumber', e.target.value)}
                className="u-form__input underline"
                style={{ border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
              />
            </div>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' }}>品項</div>
            <div style={{ flex: 1, padding: '8px' }}>
              {/* 品項的勾選邏輯（簡化為輸入欄位） */}
              <input
                list="itemTypeList"
                value={itemType || ''}
                onChange={e => onChangeFunc('itemType', e.target.value)}
                className="u-form__input underline"
                style={{  border: '1px solid rgb(204, 204, 204)', padding: '0', marginTop: '4px' }}
              />
              <datalist id="itemTypeList">
                <option value="場租" />
                <option value="餐費" />
                <option value="場租+餐費" />
              </datalist>
            </div>
          </div>

          {/* 備註事項 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' }}>備註事項</div>
            <div style={{ flex: 1, padding: '8px' }}>
              <textarea
                value={remarks || ''}
                onChange={e => onChangeFunc('remarks', e.target.value)}
                className="u-form__input underline"
                rows={3}
                style={{ resize: 'none', width: '100%', border: '1px solid #ccc', padding: '4px' }}
              />
            </div>
          </div>

          {/* 狀態選擇 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', fontWeight: 'bold' }}>狀態</div>
            <div style={{ flex: 1, padding: '8px' }}>
              <select value={typeof status === 'undefined' || status === null ? 1 : status}
                onChange={e => onChangeFunc('status', Number(e.target.value))}
                className="u-form__input underline"
                style={{ height: '36px', minHeight: '36px', fontSize: '16px', lineHeight: '1.5', padding: '6px 12px', width: '200px', border: '1px solid #ccc' }}
              >
                <option value={1}>待處理</option>
                <option value={3}>待退款</option>
                <option value={2}>待審查</option>
                <option value={4}>已完成</option>
              </select>
            </div>
          </div>

          {/* 按鈕組 */}
          <div className="u-btn-group right" style={{ padding: '16px', textAlign: 'right' }}>
            <button className="btn btn-md save" onClick={handleSave} style={{ marginRight: '16px' }}>
              儲存
            </button>
            <button className="btn btn-md cancel" onClick={e => { e.preventDefault(); toggleFunc(); }}>
              取消
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditRentall;